export function start_channels_search() {
    const channelsModal = jQuery('#tv_channels_list_modal');
    const channelsSearch = channelsModal.find('[name="channels-search"]');
    const searchInput = jQuery('[name="channels-search"');

    channelsSearch.on('input', (e) => {
        const value = e.target?.value ?? '';

        if (value.length > 1) {
            const channelsList = channelsModal.find('[data-search-value]');
            channelsList.hide();
            let found = false;
            channelsList.each((key, channel) => {
                const data = channel.dataset?.searchValue ?? '';
                if (data.toLowerCase().includes(value.toLowerCase())) {
                    found = true;
                    jQuery(channel).show();
                }
            });

            if (!found) {
                channelsModal.find('#channel_not-found').show();
            } else {
                channelsModal.find('#channel_not-found').hide();
            }

            searchInput.on('input', function () {
                if (searchInput.val().length === 1) {
                    channelsModal.find('[data-search-value]').show();
                    channelsModal.find('#channel_not-found').hide();
                }
            });
        }
    });
}

export function start_cities_search() {
    const citiesModal = jQuery('#cities_list_modal');
    const citiesSearch = citiesModal.find('[name="city-search"]');
    const searchResults = jQuery('.cities__modal-list');
    const searchNotFound = jQuery('#city_not-found');
    const citiesList = citiesModal.find('[data-search-value]');

    citiesSearch.on('input', (e) => {
        const value = e.target?.value ?? '';

        if (value.length > 1) {
            jQuery(searchResults).addClass('is_searched');
        } else {
            citiesList.show();
            citiesList.parent().show();
            searchNotFound.hide();
            jQuery(searchResults).removeClass('is_searched');
        }

        citiesList.parent().hide();
        citiesList.hide();
        let found = false;
        citiesList.each((key, city) => {
            const data = city.dataset?.searchValue ?? '';
            if (data.toLowerCase().includes(value.toLowerCase())) {
                found = true;
                jQuery(city).show();
                jQuery(city).parent().show();
            }
        });

        if (!found) {
            searchNotFound.show();
        } else {
            searchNotFound.hide();
        }

        calc_cities_wraps_height();
    });
}

let is_scrolled = false;

export function scroll_to(e) {
    if (is_scrolled) {
        e.preventDefault();
        return;
    }

    let hash = jQuery(this)[0].getAttribute('href');
    let elems = [];

    try {
        elems = document?.querySelectorAll(String(hash)) ?? [];
        // eslint-disable-next-line no-warning-comments
        // eslint-disable-next-line no-empty
    } catch {}

    let target = null;

    elems.forEach((item) => {
        if (jQuery(item).css('display') !== 'none') {
            target = jQuery(item);
            return;
        }
    });

    if (Array.from(hash)[0] !== '#' || !target || !target.get(0)) return;

    e.preventDefault();

    is_scrolled = true;

    jQuery('html, body').animate(
        {
            scrollTop: target.offset().top - 170
        },
        750,
        function () {
            is_scrolled = false;
        }
    );
}

function check_leaves_block(child, parent) {
    return child.position().left + child.width() > parent.position().left + parent.width();
}

export function show_choose_city_popup() {
    jQuery.fancybox.open({
        src: '#cities_list_modal',
        touch: false,
        beforeClose() {
            window.removeEventListener('resize', calc_cities_wraps_height);
        }
    });

    window.addEventListener('resize', calc_cities_wraps_height);
    calc_cities_wraps_height();
}

function calc_cities_wraps_height() {
    const cities_block = jQuery('#cities_list_modal');
    const cities_list = cities_block.find('.cities__modal-list');
    const items = cities_block.find('.cities__modal-items').filter(function () {
        const element = jQuery(this);

        if (element.css('display') == 'none') {
            return false;
        }

        return true;
    });

    const items_last = jQuery(items[items.length - 1]);

    const column = Math.floor(Number(cities_list.width()) / Number(items_last.width()));
    const height_first = cities_list.height() / column;
    let max_stack = 1000;

    cities_list.height(height_first);

    inc_height();

    function inc_height() {
        max_stack -= 1;

        if (!max_stack || !check_leaves_block(items_last, cities_list)) {
            return;
        }

        cities_list.height(cities_list.height() + 50);
        inc_height();
    }
}
